import React from 'react';
import './index.scss';


//material-ui
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';


//custom component


//other libraries
import { inject, observer } from 'mobx-react';


@inject('translate')
@inject('internal')
@observer
export default class ChooseCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedObjects: [],
            values: [this.props.categories],
            available_categories: [this.props.available_categories],
            selectedNames: []
        }
    }

    componentDidMount() {
    
    }

    handleChange = (event) => {
        if(event.target.value !== "") {
            let values = this.state.values;
            values.splice(event.target.value.level+1);
            let selectedObj = this.state.selectedObjects
            selectedObj.splice(event.target.value.level);
            selectedObj.push(event.target.value)
            this.setState({selectedObjects: selectedObj})

            let selectedNames = this.state.selectedNames
            selectedNames.push(event.target.value.name)
            this.setState({selectedNames: selectedNames})

            if(event.target.value.children.length) {
                values.push(event.target.value.children)
                this.setState({values: values})
            }
        }
        
    }

    action = (data) => {
        if(this.state.selectedObjects.length){
            this.props.setCategory(this.state.selectedObjects[this.state.selectedObjects.length - 1].id)
        }
        else{
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.WRONG_CATEGORY, true)
        }
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
                
            >
                <DialogTitle id="form-dialog-title">{this.props.translate.i18n.MODULES.PRODUCTS.EDIT_CATEGORY}</DialogTitle>
                <DialogContent className={'categorise-dialog'}>
                    
                    {
                        this.state.values.map((options, index) => {return (
                            <React.Fragment key={index}>
                            <FormControl className='tags-selector'>
                                {index === 0 ? <InputLabel htmlFor={`category-${index}`} className={'label-select-tag'}>{this.props.translate.i18n.MODULES.PRODUCTS.CHOOSE_CATEGORY}</InputLabel> : null }
                                <Select
                                    className={'select-category'}
                                    value={this.state.selectedObjects[index] ? this.state.selectedObjects[index].name : ""}
                                    onChange={this.handleChange}
                                    renderValue={() => {return(<span>{this.state.selectedObjects[index].name}</span>)}}
                                >
                                    {
                                        index > 0 ? <MenuItem key="0" value="">{this.props.translate.i18n.MODULES.PRODUCTS.CATEGORY_NONE}</MenuItem> : null
                                    }
                                    {
                                        options.map((option, optionIndex) => {
                                            return (
                                                option.available ?
                                                    <MenuItem key={optionIndex} value={option}>{option.name}</MenuItem>
                                                    :
                                                    null
                                            )
                                        })
                                    }
                                </Select>
                                </FormControl>
                            </React.Fragment>
                        )})
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <Button onClick={this.action} className={'orange-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button>
                </DialogActions>
                
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/invisible/addCategory/index.js